import images from "./images";

const process = [
  {
    id: 1,
    image: images.step1,
    title: "Water Sourcing",
    content: "We collect fresh water from approved, clean, and sustainable natural sources.",
  },
  {
    id: 2,
    image: images.step2,
    title: "Water Treatment",
    content: "Water is purified through advanced filtration and ensuring health safety standards.",
  },
  {
    id: 3,
    image: images.step3,
    title: "Water Packaging",
    content: "Clean water is sealed into durable, eco-friendly bottles that meet safety and hygiene guidelines.",
  },
  {
    id: 4,
    image: images.step4,
    title: "Order Placement",
    content: "Customers place water delivery orders online or by phone with simple and fast processing.",
  },
  {
    id: 5,
    image: images.step5,
    title: "Transporting Water",
    content: "Sealed water bottles are transported safely to distribution centers using delivery vehicles.",
  },
  {
    id: 6,
    image: images.step6,
    title: "Water Delivery",
    content: "Your water arrives on time, sealed, safe, and ready for home, office, or industrial use.",
  },
];

export default process;